export default function institutionsReducer(
  state = { institution_users: [] },
  action
) {
  switch (action.type) {
    case "UNLINK_INSTITUTION_USER_SUCCESS":
      return {
        ...state,
        institution_users: [
          ...state.institution_users.filter(
            ({ token_id }) => token_id != action.token_id
          )
        ]
      }
    case "REFRESH_INSTITUTIONS_SUCCESS":
      return {
        ...state,
        institution_users: action.payload.institution_users
      }
    case "CREATE_INSTITUTION_USER_SUCCESS":
      return {
        ...state,
        institution_users: [
          ...state.institution_users,
          action.payload.institution_user
        ]
      }
    case "TOGGLE_INSTITUTION_ACCOUNT_REQUEST":
    case "TOGGLE_INSTITUTION_ACCOUNT_SUCCESS":
      return {
        ...state,
        institution_users: [
          ...state.institution_users.map(iu => {
            return {
              ...iu,
              institution_accounts: iu.institution_accounts.map(ia => {
                if (ia.token_id == action.payload.token_id)
                  return {
                    ...ia,
                    excluded: action.payload.excluded
                  }
                return ia
              })
            }
          })
        ]
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/models/institutionsReducer.js